import { Typography, Link, TypographyProps } from "@mui/material";
import { FC } from "react";
import { Link as RouterLink } from "react-router-dom";


interface TermsOfUseTextProps {
  TextProps?: TypographyProps;
  leadingText?: string;
}

const TermsOfUseText: FC<TermsOfUseTextProps> = ({
  TextProps,
  leadingText,
}) => {
  return (
    <Typography
      color="textSecondary"
      variant="body2"
      {...TextProps}
    >
      {leadingText}
      {' '}
      <Link
        color="primary"
        component={RouterLink}
        to="/customer-agreement"
        underline="hover"
      >
        Customer Agreement
      </Link>
      {' '}
      and
      {' '}
      <Link
        color="primary"
        underline="hover"
        component={RouterLink}
        to="/privacy-notice"
      >
        Privacy Notice
      </Link>
      .
    </Typography>
  )
}

export default TermsOfUseText;
